import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { format } from "date-fns";
import { useDispatch } from "react-redux";
import axios from "axios";
import { Api, BaseUrl } from "../../Config/Api";
import { toast } from "react-toastify";
import { setGiftCardShow, } from "../../Redux/Action";
import { COLOR, FONT, IMAGE } from "../../Config/Color";
import Card from "../../Component/Card";
import { ImageUrl } from "../../Config/Image";
import MainLayout from "../../../layouts/MainLayout";
import { getHolidayData, getReminder } from "../../../redux/actions/employeeActions";
import ProfileDetailsCard from "../../Component/ProfileDetailsCard";
import Loader from "../../../components/Loader";
import AttendanceCard from "../../../cards/AttendanceCard ";
import { callApi } from "../../../config/apiCall";
const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];


const EmployeeDashbord = () => {
  const employeeId = sessionStorage.getItem("employeeId");
  const token = sessionStorage.getItem("authToken");
  const [useTodayHolidayArray, setTodayHolidayArray] = useState([]);
  const profileData = useSelector((state) => state.employeeData?.profile)
  const isLoading = useSelector((state) => state.employeeData?.loading)
  const currentMonth = months[new Date().getMonth()];
  const [leaveData, setLeaveData] = useState([]);
  const [attendanceData, setAttandanceData] = useState([]);
  const [filteredLeaveData, setFilteredLeaveData] = useState([]);
  const [leaveWfh, SetLeaveWfh] = useState([]);
  const currentYear = new Date().getFullYear();
  const currentMonthIndex = new Date().getMonth();
  const currentDate = format(new Date(), "yyyy-MM-dd");
  const currentDate1 = new Date();
  const month = currentDate1.getMonth() + 1;
  const day = currentDate1.getDate();
  const [modalCardOpen, setModalCardOpen] = useState(false);
  const getGiftCardShow = useSelector((state) => state.getGiftCardShow);
  const [cardType, setCardType] = useState("");
  const [cardData, setCardData] = useState([]);
  const [workDetails, setWorkDetails] = useState();
  const dispatch = useDispatch();
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails")) || {}
  const holidayData = useSelector((state) => state.employeeData?.holidayList)
  const reminderData = useSelector((state) => state.employeeData?.reminder);
  useEffect(() => {
    dispatch(getReminder())
  }, []);

  const currentMonthName = new Date(0, currentMonthIndex).toLocaleString(
    "default",
    { month: "long" }
  );
  const [formData, setFormData] = useState({
    leaveYear: currentYear.toString(),
    leaveMonth: currentMonthName,
  });

  useEffect(() => {
    if (profileData?.name) {
      fetchEmployeeAttendance(profileData?.id);
      getEmployeeLeave(profileData?.id)
      const date = new Date(profileData?.dob);
      const month1 = date.toLocaleString("default", { month: "long" });
      const day1 = date.getDate();
      const date1 = new Date(profileData?.doj);
      const month2 = date1.toLocaleString("default", { month: "long" });
      const day2 = date1.getDate();

      if (month1 === month && day1 === day && getGiftCardShow == false) {
        setCardType("BIRTHDAY");
        setCardData(profileData);
        openGift();
      } else if (
        month2 === month &&
        day2 === day &&
        getGiftCardShow == false
      ) {
        setCardType("Work Anniversary");
        setCardData(profileData);
        openGift();
      }

    }

  }, [profileData])

  useEffect(() => {
    getAllWfhLeaveData();
    fetchWorkDetails()
  }, []);

  // //console.log("leaveWfh" ,leaveWfh?.dashboard); 
  
  const fetchWorkDetails = async ()=>{
    try {
      const response = await callApi(`/get-production-hrs/${employeeId}`,"GET" ,"", token)
      //console.log(response);
      if(response?.success){
        setWorkDetails(response?.data)
      }
    } catch (error) {
      //console.log(error);
      
    }
  }


  const getEmployeeLeave = async (data) => {
    // setLoading(true);
    try {
      const responseData = await axios.get(
        `${BaseUrl}${Api.GET_EMPLOYEE_LEAVE}?employee_id=${data}`,
        {
          headers: {
            "X-Company-ID": userDetails.company_id,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (responseData?.data?.authenticated === false) {
        toast.error(responseData?.data?.mssg[0]);
        // logout();
      } else {
        if (responseData?.data?.valid === false) {
          // setLoading(false);
          toast.error(responseData?.data?.mssg[0], {
            position: "top-center",
            autoClose: 1000,
          });
        } else {
          setLeaveData(responseData?.data?.leaves);

          // setLoading(false);
        }
      }
    } catch (error) {
      // setLoading(false);
      console.error("API call failed:", error);
      toast.error("An error occurred. Please try again.");
    } finally {
      // setLoading(false);
    }
  };

  const fetchEmployeeAttendance = async (data) => {
    try {
      const responseData = await axios.get(
        `${BaseUrl}${Api.GET_EMPLOYEE_ATTENDANCE}?employee_id=${employeeId}`,
        {
          headers: {
            "X-Company-ID": userDetails.company_id,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (responseData?.data?.authenticated === false) {
        toast.error(responseData?.data?.mssg[0]);
        // logout();
      } else {
        if (responseData?.data?.valid === false) {
          // setLoading(false);
          toast.error(responseData?.data?.mssg[0], {
            position: "top-center",
            autoClose: 1000,
          });
        } else {
          setAttandanceData(responseData?.data?.data);
          // setLoading(false);
        }
      }
    } catch (error) {
      // setLoading(false);
      console.error("API call failed:", error);
      toast.error("An error occurred. Please try again.");
    } finally {
      // setLoading(false);
    }
  };
  const getLeaveCount = () => {
    let leavecount = leaveData?.filter((data) => {
      return data?.month == currentMonth;
    });
    const totalDays = leavecount?.reduce((sum, item) => {
      return sum + (item?.total_days || 0);
    }, 0);

    return totalDays; // Return the total
  };

  useEffect(() => {
    const filterLeaveData = () => {
      const allData = attendanceData?.filter((leave) => {
        return (
          leave.year === formData.leaveYear &&
          leave.month === formData.leaveMonth
        );
      });
      setFilteredLeaveData(allData);
    };

    filterLeaveData();
  }, [formData.leaveYear, formData.leaveMonth, attendanceData]);

  const getTotalLate = (data) => {
    const totalLate = data?.filter(
      (entry) => entry?.attendance_status == "Late"
    )?.length;
    return totalLate;
  };



  const getAllWfhLeaveData = async () => {
    // setLoading(true);
    try {
      const responseData = await axios.get(
        `${BaseUrl}${Api.GET_WFHLEAVE_DATA}`,
        {
          headers: {
            "X-Company-ID": userDetails.company_id,
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (responseData?.data?.authenticated === false) {
        toast.error(responseData?.data?.mssg[0]);
        // logout();
      } else if (responseData?.data?.valid === false) {
        toast.error(responseData?.data?.mssg[0]);
      } else {
        SetLeaveWfh(responseData?.data);
      }
    } catch (error) {
      console.error("API call failed:", error);
      toast.error("An error occurred. Please try again.");
    } finally {
      // setLoading(false);
    }
  };

  const openGift = () => {
    setModalCardOpen(true);
  };
  useEffect(() => {
    dispatch(getHolidayData())
  }, []);
  useEffect(() => {
    // //console.log("holidayData", holidayData, currentDate);
    if (holidayData.length > 0) {
      const todayHoliday = holidayData.find((holiday) => holiday.date === currentDate);
      if (todayHoliday != undefined && getGiftCardShow == false) {
        setCardType(todayHoliday?.holiday_name);
        setCardData(todayHoliday);
        openGift();
      }
      // Find all holidays of this month
      const currentDateObj = new Date();
      const currentMonth = currentDateObj.getMonth() + 1; // getMonth() is 0-based
      const currentYear = currentDateObj.getFullYear();

      const currentMonthHolidays = holidayData.filter((holiday) => {
        const [year, month] = holiday.date.split('-').map(Number);
        return year === currentYear && month === currentMonth;
      });

      setTodayHolidayArray(currentMonthHolidays || []);

    }
  }, [holidayData])


  // //console.log("isLoading " ,profileData?.shift?.shift_duration);


  return (
    <MainLayout>
      <div className="page-wrapper">
          {
            isLoading &&
            <Loader style={{
              background: "#00000029",
              zIndex: "1000",
              top: "0",
              left: "0",
              height: "100%"
            }} />
          }
        <div className="content p-0">
          <div className="w-full relative  h-full">
            <div className="relative w-full h-full">
              <img
                style={{ maxHeight: "190px" }}
                src="/assets/Assets/NewImage/background.png"
                alt="background"
                className="w-full h-full object-cover"
              />
            </div>

            <ProfileDetailsCard />
            <div className="absolute top-[335px] left-1/2 transform -translate-x-1/2 w-[94%] rounded-lg p-0 flex justify-between space-x-4 ">
              {/* Card Wrapper */}
              {[
                {
                  title: "Total Employees",
                  img: ImageUrl.EMPLOYEE,
                  count: leaveWfh?.dashboard?.total_employees,
                },
                {
                  title: "Today hours ",
                  bgColor: "#047EFF",
                  icon: "ti ti-clock-stop",
                  count: `${workDetails?.today?.worked_hours.toFixed(2)} / ${workDetails?.today?.required_hours}`,
                },
                {
                  title: "Week Hours",
                  bgColor: "#000000",
                  icon: "ti ti-clock-up",
                  count: `${workDetails?.week?.worked_hours.toFixed(2)} / ${workDetails?.week?.required_hours}`,
                },
                {
                  title: "Month Hours",
                  bgColor: "#1b84ff",
                  icon: "ti ti-calendar-up",
                  count: `${workDetails?.month?.worked_hours.toFixed(2)} / ${workDetails?.month?.required_hours}`,
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className="flex items-center w-1/4 h-[80px] bg-white shadow-md rounded-lg p-4">
                  {/* Icon */}
                  <div className="mr-4">
                    {
                      item?.icon ?
                        <span style={{background:item.bgColor}} class="avatar avatar-lg flex-shrink-0">
                          <i class={item?.icon}>
                          </i></span> :
                        <img src={item.img} alt={item.title} className="w-10 h-10" />
                    }
                  </div>


                  {/* Text */}
                  <div>
                    <b>
                      {item.count || 0}
                    </b>
                    <p
                      style={{
                        color: "#6b7280",
                        fontSize: "14px",
                        fontWeight: "500",
                        //fontFamily: "Inter",
                        color: COLOR.BLACK1,
                      }}
                    >
                      {item.title}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            <div
              style={{
                width: "95%",
                display: "flex",
                justifyContent: "space-between",
              }}
              className="absolute top-[450px]  left-1/2  transform -translate-x-1/2 verflow-y-auto min-w-0"
            >
              <div style={{ width: "49%", marginBottom: "25px" }}>
                <div className="bg-white shadow-md rounded-lg p-6 w-full h-[550px] overflow-y-auto min-w-0">
                  <div className="flex justify-between items-center border-b pb-3 mb-4">
                    <h2
                      style={{
                        color: COLOR?.BLACK2,
                        fontSize: "16px",
                        fontWeight: "600",
                        fontFamily: FONT?.INTER,
                        lineHeight: "24px",
                      }}
                    >
                      Profile Details
                    </h2>
                    <img src={IMAGE.PROFILE} className="w-7 h-7" alt="icon" />
                  </div>

                  <div className="grid grid-cols-1 gap-y-3 text-gray-700">
                    <div className="flex justify-between">
                      <strong
                        style={{
                          color: "#373A3C",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          fontFamily: FONT?.INTER,
                        }}
                      >
                        Employee ID
                      </strong>{" "}
                      <span
                        style={{
                          color: "#1A1A1A",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          fontFamily: FONT?.INTER,
                        }}
                      >
                        {profileData?.employee_code}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <strong
                        style={{
                          color: "#373A3C",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          fontFamily: FONT?.INTER,
                        }}
                      >
                        Blood Group
                      </strong>{" "}
                      <span
                        style={{
                          color: "#1A1A1A",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          fontFamily: FONT?.INTER,
                        }}
                      >
                        {profileData?.blood_group}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <strong
                        style={{
                          color: "#373A3C",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          fontFamily: FONT?.INTER,
                        }}
                      >
                        Date of Birth
                      </strong>{" "}
                      <span
                        style={{
                          color: "#1A1A1A",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          fontFamily: FONT?.INTER,
                        }}
                      >
                        {profileData?.dob}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <strong
                        style={{
                          color: "#373A3C",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          fontFamily: FONT?.INTER,
                        }}
                      >
                        Department
                      </strong>{" "}
                      <span
                        style={{
                          color: "#1A1A1A",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          fontFamily: FONT?.INTER,
                        }}
                      >
                        {profileData?.department}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <strong
                        style={{
                          color: "#373A3C",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          fontFamily: FONT?.INTER,
                        }}
                      >
                        Designation
                      </strong>{" "}
                      <span
                        style={{
                          color: "#1A1A1A",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          fontFamily: FONT?.INTER,
                        }}
                      >
                        {profileData?.designation}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <strong
                        style={{
                          color: "#373A3C",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          fontFamily: FONT?.INTER,
                        }}
                      >
                        Experience
                      </strong>{" "}
                      <span
                        style={{
                          color: "#1A1A1A",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          fontFamily: FONT?.INTER,
                        }}
                      >
                        {profileData?.experience}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <strong
                        style={{
                          color: "#373A3C",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          fontFamily: FONT?.INTER,
                        }}
                      >
                        Total Experience
                      </strong>{" "}
                      <span
                        style={{
                          color: "#1A1A1A",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          fontFamily: FONT?.INTER,
                        }}
                      >
                        {profileData?.total_experience}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <strong
                        style={{
                          color: "#373A3C",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          fontFamily: FONT?.INTER,
                        }}
                      >
                        Date of Joining
                      </strong>{" "}
                      <span
                        style={{
                          color: "#1A1A1A",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          fontFamily: FONT?.INTER,
                        }}
                      >
                        {profileData?.doj}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <strong
                        style={{
                          color: "#373A3C",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          fontFamily: FONT?.INTER,
                        }}
                      >
                        Reporting Manager
                      </strong>{" "}
                      <span
                        style={{
                          color: "#1A1A1A",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          fontFamily: FONT?.INTER,
                        }}
                      >
                        {profileData?.reporting_manager}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <strong
                        style={{
                          color: "#373A3C",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          fontFamily: FONT?.INTER,
                        }}
                      >
                        Employee Status
                      </strong>{" "}
                      <span
                        style={{
                          color: "#1A1A1A",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          fontFamily: FONT?.INTER,
                        }}
                      >
                        {profileData?.status}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <strong
                        style={{
                          color: "#373A3C",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          fontFamily: FONT?.INTER,
                        }}
                      >
                        Office Location
                      </strong>{" "}
                      <span
                        style={{
                          color: "#1A1A1A",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          fontFamily: FONT?.INTER,
                        }}
                      >
                        {profileData?.office_location}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <strong
                        style={{
                          color: "#373A3C",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          fontFamily: FONT?.INTER,
                        }}
                      >
                        Shift Zone
                      </strong>
                      <span
                        style={{
                          color: "#1A1A1A",
                          fontSize: "16px",
                          fontWeight: "400",
                          lineHeight: "24px",
                          fontFamily: FONT?.INTER,
                        }}
                      >
                        {profileData?.shift?.name || profileData?.shift_timing}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="bg-white shadow-md rounded-lg p-4 mt-[20px]">
                  <div className="flex justify-between items-center border-b pb-2 mb-3">
                    <h3
                      style={{
                        color: COLOR?.BLACK2,
                        fontSize: "16px",
                        fontWeight: "600",
                        fontFamily: FONT?.INTER,
                        lineHeight: "24px",
                      }}
                    >
                      Leave This Month
                    </h3>

                    <img
                      src={IMAGE.LEAVE}
                      alt="Profile"
                      style={{
                        width: "25px",
                        height: "25px",
                        fill: "#888888",
                      }}
                    />
                  </div>

                  <div className="flex justify-between">
                    <strong
                      style={{
                        color: "#2D3142",
                        fontSize: "16px",
                        fontWeight: "400",
                        fontFamily: FONT?.INTER,
                      }}
                    >
                      Leave:
                    </strong>{" "}
                    <span
                      style={{
                        color: "#1A1A1A",
                        fontSize: "16px",
                        fontWeight: "400",
                        fontFamily: FONT?.INTER,
                        marginRight: 8,
                      }}
                    >
                      {getLeaveCount()}
                    </span>
                  </div>
                </div>

                <div className="bg-white shadow-md rounded-lg p-4 mt-[20px]">
                  <div className="flex justify-between items-center border-b pb-2 mb-3">
                    <h3
                      style={{
                        color: COLOR?.BLACK2,
                        fontSize: "16px",
                        fontWeight: "600",
                        fontFamily: FONT?.INTER,
                        lineHeight: "24px",
                      }}
                    >
                      Late This Month
                    </h3>
                    <img
                      src={IMAGE.LATE}
                      alt="Profile"
                      style={{
                        width: "25px",
                        height: "25px",
                        fill: "#888888",
                      }}
                    />
                  </div>

                  <div className="flex justify-between">
                    <strong
                      style={{
                        color: "#2D3142",
                        fontSize: "16px",
                        fontWeight: "400",
                        fontFamily: FONT?.INTER,
                      }}
                    >
                      Total Late:
                    </strong>
                    <span
                      style={{
                        color: "#1A1A1A",
                        fontSize: "16px",
                        fontWeight: "400",
                        fontFamily: FONT?.INTER,
                        // display:'flex',
                        marginRight: 8,
                      }}
                    >
                      {getTotalLate(filteredLeaveData)}
                    </span>
                  </div>
                </div>
              </div>
              <div style={{ width: "49%", marginBottom: "25px" }}>
                <div className="flex flex-col gap-4 w-full  min-w-0">
                  {/* working hours show  */}
                  <div className="bg-white shadow-md rounded-lg ">
                    <AttendanceCard shiftHours={profileData?.shift?.shift_duration} />
                  </div>

                  <div className="bg-white shadow-md rounded-lg p-4">
                    <div className="flex justify-between items-center border-b pb-2 mb-3">
                      <h3
                        style={{
                          color: "#2D3142",
                          fontSize: "16px",
                          fontWeight: "600",
                          fontFamily: FONT?.INTER,
                          lineHeight: "24px",
                        }}
                      >
                        Celebration This Month
                      </h3>
                      <img
                        src={IMAGE.CAKE}
                        alt="Profile"
                        style={{
                          width: "25px",
                          height: "25px",
                          fill: "#888888",
                        }}
                      />
                    </div>
                    <div className="  h-[150px] overflow-y-auto min-w-0">
                      {reminderData?.current_events?.length > 0 ||
                        reminderData?.upcoming_events?.length > 0 ? (
                        (() => {
                          // Combine current events and upcoming events, then filter for birthdays in the current month
                          const birthdayItems = [
                            ...(reminderData?.current_events || []),
                            ...(reminderData?.upcoming_events || []),
                          ].filter((item) => {
                            if (
                              item.type !== "Birthday" &&
                              item.type !== "Anniversary"
                            )
                              return false;

                            const itemDate = new Date(item.date);
                            const currentMonth = new Date().getMonth(); // Get current month (0-indexed)
                            const currentYear = new Date().getFullYear(); // Get current year

                            // Check if the item's month and year match the current month and year
                            return (
                              itemDate.getMonth() === currentMonth &&
                              itemDate.getFullYear() === currentYear
                            );
                          });

                          return birthdayItems.length > 0 ? (
                            birthdayItems.map((birthdayItem, index) => {
                              const date = new Date(birthdayItem.date);
                              const day = new Intl.DateTimeFormat("en-US", {
                                weekday: "long",
                              }).format(date);

                              return (
                                <div
                                  key={index}
                                  style={{
                                    width: "100%",
                                    flexDirection: "row",
                                    padding: 5,
                                    paddingRight: 20,
                                    justifyContent: "space-between",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    style={{
                                      width: "40%",
                                      alignItems: "flex-start",
                                      justifyContent: "flex-start",
                                      display: "flex",
                                    }}
                                  >
                                    <h3
                                      style={{
                                        color: "#2D3142",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        fontFamily: FONT?.INTER,
                                        marginTop: "12px",
                                        lineHeight: "20px",
                                      }}
                                    >
                                      <span
                                        style={{
                                          color: "#2D3142",
                                          marginRight: "10px",
                                        }}
                                      >
                                        ●
                                      </span>
                                      {birthdayItem?.name} ({birthdayItem.type})
                                    </h3>
                                  </div>
                                  <div
                                    style={{
                                      width: "30%",
                                      alignItems: "flex-end",
                                      justifyContent: "flex-end",
                                      display: "flex",
                                    }}
                                  >
                                    <span
                                      style={{
                                        color: "#2D3142",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        fontFamily: FONT?.INTER,
                                        marginTop: "12px",
                                        lineHeight: "20px",
                                      }}
                                    >
                                      {birthdayItem?.date}
                                    </span>
                                  </div>

                                  <div
                                    style={{
                                      width: "30%",
                                      alignItems: "flex-end",
                                      justifyContent: "flex-end",
                                      display: "flex",
                                    }}
                                  >
                                    <span
                                      style={{
                                        color: "#2D3142",
                                        fontSize: "14px",
                                        fontWeight: "500",
                                        fontFamily: FONT?.INTER,
                                        marginTop: "12px",
                                        lineHeight: "20px",
                                      }}
                                    >
                                      {day}
                                    </span>
                                  </div>
                                </div>
                              );
                            })
                          ) : (
                            <div
                              style={{
                                textAlign: "center",
                                color: "#888888",
                                fontWeight: "600",
                                marginTop: "20px",
                                marginBottom: "50px",
                              }}
                            >
                              No birthdays this month.
                            </div>
                          );
                        })()
                      ) : (
                        <div
                          style={{
                            display: "flex", // Add this line
                            flexDirection: "column", // Add this line to stack items vertically
                            color: "#888888",
                            fontWeight: "600",
                            marginTop: "20px",
                            justifyContent: "center",
                            alignItems: "center",
                            // height: "100vh", // Optional: Ensure the div takes the full height of the viewport
                          }}
                        >
                          <img
                            src={ImageUrl.NODATA}
                            style={{
                              width: "50px",
                              height: "50px",
                            }}
                          />
                          <p
                            style={{
                              fontWeight: "600",
                              fontSize: "14px",
                              //fontFamily: "Inter",
                              color: COLOR.GRAY1,
                            }}
                          >
                            No events this month.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="bg-white shadow-md rounded-lg p-4">
                    <div className="flex justify-between items-center border-b pb-2 mb-3">
                      <h3
                        style={{
                          color: "#2D3142",
                          fontSize: "16px",
                          fontWeight: "600",
                          fontFamily: FONT?.INTER,
                          lineHeight: "24px",
                        }}
                      >
                        Holiday's This Month
                      </h3>

                      <img
                        src={ImageUrl.CALENDER1}
                        alt="Profile"
                        style={{
                          width: "25px",
                          height: "25px",
                          fill: "#888888",
                        }}
                      />
                    </div>

                    <div
                      style={{
                        width: "100%",
                        height: "155px",
                        alignSelf: "center",
                        padding: "10px",
                        overflowY: "auto", // Makes it scrollable
                      }}
                    >
                      {useTodayHolidayArray && useTodayHolidayArray?.length > 0 ? useTodayHolidayArray?.map((holidayItem, index) => {
                        const date = new Date(holidayItem.date);
                        const day = new Intl.DateTimeFormat("en-US", {
                          weekday: "long",
                        }).format(date);
                        return (
                          <div
                            key={index}
                            style={{
                              width: "100%",
                              flexDirection: "row",
                              padding: 5,
                              paddingRight: 20,
                              justifyContent: "space-between",
                              display: "flex",
                              alignItems: "center",
                              marginBottom: "10px",
                            }}
                          >
                            <div style={{ width: "40%" }}>
                              <div style={{ display: "flex" }}>
                                <span
                                  style={{
                                    color: "#2D3142",
                                    marginRight: "10px",
                                  }}
                                >
                                  ●
                                </span>
                                <h3 style={{
                                  color: "#2D3142",
                                  fontSize: "14px",
                                  fontWeight: "500",
                                  fontFamily: FONT?.INTER,

                                  lineHeight: "20px",
                                }}
                                >
                                  {holidayItem?.holiday_name}
                                </h3>
                              </div>
                            </div>
                            <div
                              style={{
                                width: "30%",
                                alignItems: "flex-end",
                                justifyContent: "flex-end",
                                display: "flex",
                              }}
                            >
                              <span
                                style={{
                                  color: "#2D3142",
                                  fontSize: "14px",
                                  fontWeight: "500",
                                  fontFamily: FONT?.INTER,

                                  lineHeight: "20px",
                                }}
                              >
                                {holidayItem?.date}
                              </span>
                            </div>
                            <div
                              style={{
                                width: "30%",
                                alignItems: "flex-end",
                                justifyContent: "flex-end",
                                display: "flex",
                              }}
                            >
                              <span
                                style={{
                                  color: "#2D3142",
                                  fontSize: "14px",
                                  fontWeight: "500",
                                  fontFamily: FONT?.INTER,

                                  lineHeight: "20px",
                                }}
                              >
                                {day}
                              </span>
                            </div>
                          </div>
                        );
                      }) :
                        (
                          <div
                            style={{
                              display: "flex", // Add this line
                              flexDirection: "column", // Add this line to stack items vertically
                              color: "#888888",
                              fontWeight: "600",
                              marginTop: "20px",
                              justifyContent: "center",
                              alignItems: "center",
                              // height: "100vh", // Optional: Ensure the div takes the full height of the viewport
                            }}
                          >
                            <img
                              src={ImageUrl.NODATA}
                              style={{
                                width: "50px",
                                height: "50px",
                              }}
                            />
                            <p
                              style={{
                                fontWeight: "600",
                                fontSize: "14px",
                                //fontFamily: "Inter",
                                color: COLOR.GRAY1,
                              }}
                            >
                              No holiday this month.
                            </p>
                          </div>
                        )}
                    </div>
                  </div>
                  <div className="bg-white shadow-md rounded-lg p-4">
                    <div className="flex justify-between items-center border-b pb-2 mb-5">
                      <h3
                        style={{
                          color: "#2D3142",
                          fontSize: "16px",
                          fontWeight: "600",
                          fontFamily: FONT?.INTER,
                          lineHeight: "24px",
                        }}
                      >
                        Leave/WFH (Today)
                      </h3>

                      <img
                        src={IMAGE.LEAVE}
                        alt="Profile"
                        style={{
                          width: "25px",
                          height: "25px",
                          fill: "#888888",
                        }}
                      />
                    </div>

                    <div
                      style={{
                        width: "100%",
                        height: "155px",
                        alignSelf: "center",
                        padding: "10px",
                        overflowY: "auto", // Makes it scrollable
                      }}
                    >
                      {leaveWfh?.data && leaveWfh?.data?.length > 0 ? (
                        <>
                          {leaveWfh?.data?.map((holidayItem, index) => {
                            return (
                              <div
                                key={index}
                                style={{
                                  width: "100%",
                                  flexDirection: "row",
                                  padding: 5,
                                  paddingRight: 20,
                                  justifyContent: "space-between",
                                  display: "flex",
                                  alignItems: "center",
                                  marginBottom: "10px",
                                }}
                              >
                                <div style={{ width: "40%" }}>
                                  <h3
                                    style={{
                                      color: "#2D3142",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                      fontFamily: FONT?.INTER,

                                      lineHeight: "20px",
                                    }}
                                  >
                                    {holidayItem?.name}
                                  </h3>
                                </div>

                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: "#E6F2FF",
                                    padding: "5px 20px",
                                    borderRadius: 20,
                                  }}
                                >
                                  <div
                                    style={{
                                      width: 10,
                                      height: 10,
                                      borderRadius: "50%",
                                      background: "#047EFF",
                                    }}
                                  />
                                  <span
                                    style={{
                                      color: "#047EFF",
                                      fontWeight: "500",
                                      marginLeft: 10,
                                      marginTop: 3,
                                      fontSize: "14px",
                                      lineHeight: "20px",
                                    }}
                                  >
                                    {holidayItem?.attendance_status}
                                  </span>
                                </div>
                                <div
                                  style={{
                                    width: "30%",
                                    alignItems: "flex-end",
                                    justifyContent: "flex-end",
                                    display: "flex",
                                  }}
                                >
                                  <span
                                    style={{
                                      color: "#2D3142",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                      fontFamily: FONT?.INTER,

                                      lineHeight: "20px",
                                    }}
                                  >
                                    {holidayItem?.date}
                                    {holidayItem?.date &&
                                      ` (${new Date(
                                        holidayItem.date
                                      ).toLocaleDateString("en-US", {
                                        weekday: "long",
                                      })})`}
                                  </span>
                                </div>
                              </div>
                            );
                          })}
                        </>
                      ) : (
                        <div
                          style={{
                            display: "flex", // Add this line
                            flexDirection: "column", // Add this line to stack items vertically
                            color: "#888888",
                            fontWeight: "600",
                            marginTop: "20px",
                            justifyContent: "center",
                            alignItems: "center",
                            // height: "100vh", // Optional: Ensure the div takes the full height of the viewport
                          }}
                        >
                          <img
                            src={ImageUrl.NODATA}
                            style={{
                              width: "50px",
                              height: "50px",
                            }}
                          />
                          <p
                            style={{
                              fontWeight: "600",
                              fontSize: "14px",
                              //fontFamily: "Inter",
                              color: COLOR.GRAY1,
                            }}
                          >
                            No Leave/WFH data available.
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Card
              open={modalCardOpen}
              onClose={() => {
                setModalCardOpen(false);
                dispatch(setGiftCardShow(true));
              }}
              data={cardData}
              type={cardType}
            />
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default EmployeeDashbord;
